import React from "react";
import { Box, Card as MUICard, CardContent, Typography } from "@mui/material";
import { useApp } from "context";
import { Custom } from "components";
import { Light } from "themes";
import { Helpers } from "utils";
import { IconButton } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

type Props = {
  sx?: any;
  title?: string;
  titleSx?: any;
  href?: string;
  action?: React.ReactNode;
  actionSx?: any;
  children?: React.ReactNode;
  // for collapsing the card
  opened?: boolean;
  toggle?: () => void;
};

export const Card = (props: Props) => {
  const { t, theme } = useApp();

  const hasTitle = Helpers.hasValue(props.title);

  return (
    <MUICard
      sx={{
        color: theme.palette.font.color,
        borderRadius: theme.border.radius,
        boxShadow:
          theme.id === Light.id
            ? "0 3px 10px 0 " + theme.palette.shadow.color
            : "unset",
        // backgroundColor: theme.palette.theme,
        backgroundColor: theme.palette.background.accent,
        ...(props.sx?.height && { height: props.sx?.height }),
      }}
    >
      <CardContent sx={props.sx}>
        {hasTitle ? (
          <Typography
            sx={{
              alignItems: "center",
              fontSize: theme.font.lg,
              marginBottom: theme.margin.md,
              ...props.titleSx,
            }}
            component="div"
          >
            {typeof props.opened === "boolean" ? (
              <IconButton
                onClick={props.toggle}
                sx={{ color: theme.palette.font.color }}
                disableRipple
                disableFocusRipple
                disableTouchRipple
              >
                {props.title}
                {props.opened ? (
                  <KeyboardArrowUpIcon
                    fontSize="large"
                    sx={{ color: theme.palette.font.color }}
                  />
                ) : (
                  <KeyboardArrowDownIcon
                    fontSize="large"
                    sx={{ color: theme.palette.font.color }}
                  />
                )}
              </IconButton>
            ) : (
              props.title
            )}
            <Box
              sx={{
                float: "right",
                ...(props.opened === false && { display: "none" }),
                ...props.actionSx,
              }}
            >
              {props.href ? (
                <Custom.Button
                  size="small"
                  variant="outlined"
                  href={props.href}
                >
                  {t.action.view_all}
                </Custom.Button>
              ) : (
                props.action
              )}
            </Box>
          </Typography>
        ) : null}

        {props.opened === false ? (
          <div style={{ display: "none" }}>{props.children}</div>
        ) : (
          props.children
        )}
      </CardContent>
    </MUICard>
  );
};
